import { render } from "./RequestPasswordResetSuccessful.vue?vue&type=template&id=abe8f4e2"
import script from "./RequestPasswordResetSuccessful.vue?vue&type=script&lang=js"
export * from "./RequestPasswordResetSuccessful.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__